module.exports = "<suite-input-codes [typeTags]=\"typeTags\"></suite-input-codes>\n"